import { render, staticRenderFns } from "./Forbiden.vue?vue&type=template&id=e68c69cc&"
import script from "./Forbiden.vue?vue&type=script&lang=js&"
export * from "./Forbiden.vue?vue&type=script&lang=js&"
import style0 from "./Forbiden.vue?vue&type=style&index=0&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports